import { create } from 'zustand'
import { ListStore } from '../components/core/InfiniteScrollList/types'
import { storeRegistry } from './storeRegistry'

export function createListStore() {
  const store = create<ListStore>((set) => ({
    filters: {},
    sortBy: null,
    sortDirection: 'desc' as const,

    setFilter: (key: string, value: string) => {
      set(({ filters }) => ({
        filters: { ...filters, [key]: value },
      }))
    },

    setSort: (key: string | null, direction: 'asc' | 'desc') => {
      set({
        sortBy: key,
        sortDirection: direction,
      })
    },

    reset: () => {
      set({
        filters: {},
        sortBy: null,
        sortDirection: 'desc',
      })
    },
    
    refresh: () => {
      // Add a timestamp to force a refresh since react-query 
      // doesn't trigger a new query when the filter is the same 
      set(({ filters }) => ({
        filters: { ...filters, _refresh: Date.now().toString() },
      }))
    },
  }))

  // Register the store with the registry
  storeRegistry.register(store)

  return store
} 